import { render, staticRenderFns } from "./CustomColumnsModal.vue?vue&type=template&id=3b60db86&scoped=true"
import script from "./CustomColumnsModal.vue?vue&type=script&lang=js"
export * from "./CustomColumnsModal.vue?vue&type=script&lang=js"
import style0 from "./CustomColumnsModal.vue?vue&type=style&index=0&id=3b60db86&prod&lang=scss&scoped=true"
import style1 from "./CustomColumnsModal.vue?vue&type=style&index=1&id=3b60db86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b60db86",
  null
  
)

export default component.exports